import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const promotion = createAsyncThunk(
  "promotion/promotion",
  async (payload, thunkAPI) => {
    try {
      const response = await api.get("promotion/get-list", payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("Something went wrong");
    }
  }
);

export const promotionCategory = createAsyncThunk(
  "promotion/category",
  async (payload, thunkAPI) => {
    try {
      const response = await api.get("promotion/get-category", payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("Failed to fetch promotion category");
    }
  }
);

const promotionSlice = createSlice({
  name: "promotion",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(promotion.pending, (state) => {
        state.loading = true;
      })
      .addCase(promotion.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(promotion.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

const promotionCategorySlice = createSlice({
  name: "promotionCategory",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(promotionCategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(promotionCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(promotionCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});
export const promotionReducer = promotionSlice.reducer;
export const promotionCategoryReducer = promotionCategorySlice.reducer;
